
import { API_ENDPOINTS } from '@/constants/api-endpoint';
import { post as postBe } from './backendApi';
import { post } from './api';
import { ChangeUserPasswordReq } from '@/types/request';
import { get } from './backendApi';

export interface UserLoginResponse {
  id: string;
  user_name: string;
  full_name: string;
  email: string;
  phone: string;
  last_seen: string;
  is_admin: boolean;
  token: string;
  refresh_token: string;
}

export const fetchUser = async (username: string, password: string) => {
  try {
    return await post<UserLoginResponse>(API_ENDPOINTS.LOGIN, {
      login_name: username,
      password: password,
    });
  } catch (error: any) {
    throw new Error(" " + error);
  }
};


export const logOutUser = async () => {
  return await post(API_ENDPOINTS.LOGOUT, {})
}

export interface UpdateUsersStatusRequest {
  user_ids: string[];
  status: 'active' | 'inactive';
}

export const updateUsersStatus = async (request: UpdateUsersStatusRequest) => {
  try {
    return await postBe(API_ENDPOINTS.UPDATE_USERS_STATUS, request);
  } catch (error: any) {
    throw new Error(error?.message || "Cập nhật trạng thái thất bại");
  }
}

export interface UserStatusCountsResponse {
  active_count: number;
  inactive_count: number;
  total_count: number;
}

export interface BulkUpdateStatusResponse {
  affected_count: number;
}

export const getUserStatusCounts = async (domain: string) => {
  try {
    return await get<UserStatusCountsResponse>(API_ENDPOINTS.GET_USER_STATUS_COUNTS(domain));
  } catch (error: any) {
    throw new Error(error?.message || "Lấy thống kê trạng thái thất bại");
  }
}

export const bulkActivateUsers = async (domain: string) => {
  try {
    return await postBe<BulkUpdateStatusResponse>(API_ENDPOINTS.BULK_ACTIVATE_USERS(domain), {});
  } catch (error: any) {
    throw new Error(error?.message || "Kích hoạt người dùng thất bại");
  }
}

export const bulkDeactivateUsers = async (domain: string) => {
  try {
    return await postBe<BulkUpdateStatusResponse>(API_ENDPOINTS.BULK_DEACTIVATE_USERS(domain), {});
  } catch (error: any) {
    throw new Error(error?.message || "Vô hiệu hóa người dùng thất bại");
  }
}

export const changeUserPassword = async (data: ChangeUserPasswordReq): Promise<void> => {
  try {
    await post(API_ENDPOINTS.CHANGE_USER_PASSWORD, {
      user_id: data.user_id,
      new_password: data.new_password,
    });
  } catch (error: any) {
    throw new Error(error?.message || 'Lỗi khi đổi mật khẩu người dùng');
  }
}



